// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../controllers/gallery_controller"
import "../controllers/carousel_controller"
import "../controllers/calculator_controller"
import "../controllers/auction_timer_controller"
import "../controllers/bid_form_controller"
import "../controllers/wizard_controller"
import "../controllers/comment_like_controller"
import "../controllers/comment_reply_controller"
import "../controllers/comment_flag_controller"
import "../controllers/share_controller"
import "../controllers/register_bid_controller"
import "../controllers/dynamic_list_controller"
import "../controllers/seller_chat_controller"
import "../controllers/conversation_controller"
import "../controllers/activity_sort_controller"
import "../controllers/mercadopago_card_controller"

Rails.start()
ActiveStorage.start()
